import { render, staticRenderFns } from "./adjacentArticle.vue?vue&type=template&id=d8201b8c&scoped=true&"
import script from "./adjacentArticle.vue?vue&type=script&lang=js&"
export * from "./adjacentArticle.vue?vue&type=script&lang=js&"
import style0 from "./adjacentArticle.vue?vue&type=style&index=0&id=d8201b8c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8201b8c",
  null
  
)

export default component.exports